import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileActionBar } from "./MobileActionBar";
import { AskOceanside } from "../shared/AskOceanside";
type SiteLayoutProps = {
  showAssistant: boolean;
};
export function SiteLayout({
  showAssistant
}: SiteLayoutProps) {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const target = document.getElementById(location.hash.slice(1));
      if (target) {
        requestAnimationFrame(() => target.scrollIntoView({
          block: "start"
        }));
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return <div className="min-h-screen w-full bg-paper text-charcoal" data-id="element-99" data-mp="3rwpyuc6pbvzs">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-[4px] focus:bg-charcoal focus:px-4 focus:py-3 focus:text-paper" data-id="element-100" data-mp="347dnb5nwjbub">
        Skip to content
      </a>
      <Header data-id="element-101" data-mp="1aclgrt9c8upl" />
      <main id="main" tabIndex={-1} className="focus:outline-none" data-id="element-102" data-mp="1aar3900ec4vj">
        <Outlet data-id="element-103" data-mp="1fan811gx40c5" />
      </main>
      <Footer data-id="element-104" data-mp="1f9lmg329zvg6" />
      <div aria-hidden="true" className="h-[76px] md:hidden" data-id="element-105" data-mp="1k2n2wfi4s31v" />
      <MobileActionBar data-id="element-106" data-mp="1k3gf3vzuzkre" />
      {showAssistant && <AskOceanside data-id="element-107" data-mp="1o40aov4sagbf" />}
    </div>;
}